// Click event listener for non-autoplay video elements
document.querySelectorAll('.product-video-not-autoplay video').forEach(function(media) {
  media.addEventListener('click', function() {
    var playButton = media.parentElement.querySelector('.product-video-central-play-button');

    if (media.paused || media.ended) {
      media.play();
      playButton.classList.add('hidden');
    } else {
      media.pause();
      playButton.classList.remove('hidden');
    }
  });
});

// Click event listener for autoplay video elements
document.querySelectorAll('.product-video-is-autoplay video').forEach(function(media) {
  media.addEventListener('click', function() {
    if (media.paused || media.ended) {
      media.play();
    } else {
      media.pause();
    }
  });
});